import GameMode from './GameMode.js';
import { ASTEROID_INITIAL_COUNT, SHIELD_DEFAULT_COUNT } from 'asteroids-shared/constants';

/**
 * Co-op: shared lives, shared score, no friendly fire. When all asteroids
 * are cleared the next wave gets one more rock. Game ends when the shared
 * lives pool reaches zero. With shields enabled, the lives system is
 * bypassed: each player has SHIELD_DEFAULT_COUNT shields and does not respawn.
 */
export default class CoopMode extends GameMode {
  static get name() { return 'coop'; }

  get sharedScore() { return true; }
  get bulletHitsFriendly() { return false; }
  get shipVsShipCollision() { return false; }
  get respawnDelay() { return 2000; }

  constructor({ initialLives = 3, shieldsEnabled = false } = {}) {
    super();
    this._initialLives = initialLives
    this.shieldsEnabled = shieldsEnabled === true
    this.score = 0;
    this.lives = this.initialLives;
    this.wave = 0
    this.asteroidCount = ASTEROID_INITIAL_COUNT;
    this.gameOver = null;
  }

  get initialLives() {
    return this._initialLives
  }

  onGameStart(world, players, ctx) {
    void players
    this.score = 0;
    this.lives = this.shieldsEnabled ? Infinity : this.initialLives;
    this.wave = 0;
    this.asteroidCount = ASTEROID_INITIAL_COUNT;
    this.gameOver = null;
    if (this.shieldsEnabled) {
      for (const ship of world.ships.values()) {
        ship.shieldMax = SHIELD_DEFAULT_COUNT
        ship.shieldHealth = SHIELD_DEFAULT_COUNT
      }
    }
    world.spawnAsteroidWave(this.asteroidCount);
    ctx.broadcastScore({ score: this.score, lives: this.lives });
  }

  onAsteroidDestroyed(world, asteroid, byPlayerId, ctx) {
    void world
    if (byPlayerId == null) return;     // ship-asteroid collision, no scorer
    this.score += asteroid.score;
    ctx.broadcastScore({ score: this.score, lives: this.lives });
  }

  onShipHit(world, ship, hitBy, ctx) {
    void world
    void hitBy
    if (this.shieldsEnabled) {
      // Shields replace lives: no respawn, no shared lives counter to drain.
      ctx.broadcastScore({ score: this.score, lives: this.lives });
      return
    }
    this.lives -= 1;
    ctx.broadcastScore({ score: this.score, lives: this.lives });
    if (this.lives > 0) {
      ctx.scheduleRespawn(ship.id, this.respawnDelay);
    }
  }

  onAllAsteroidsCleared(world, _ctx) {
    this.wave += 1;
    this.asteroidCount += 1;
    world.spawnAsteroidWave(this.asteroidCount);
  }

  checkGameOver(world) {
    if (this.shieldsEnabled) {
      const anyAlive = world && [...world.ships.values()].some(s => s.alive)
      if (world && !anyAlive && world.ships.size > 0) {
        return { reason: 'all_players_down', finalScore: this.score, wavesCleared: this.wave };
      }
      return null;
    }
    if (this.lives <= 0) {
      return { reason: 'out_of_lives', finalScore: this.score, wavesCleared: this.wave };
    }
    return null;
  }
}
